import React from 'react';
import styled from '../../styled';
const Icon = styled.div `
  box-sizing: border-box;
  width: ${({ theme, size }) => theme.avatar.diameter[size]};
  height: ${({ theme, size }) => theme.avatar.diameter[size]};
  border-radius: 50%;
  border: ${({ theme, size }) => size === 'LARGE'
    ? `solid 0.09375rem ${theme.colors.SNOW_300}`
    : `solid 0.0625rem ${theme.colors.SNOW_300}`};
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  background-image: url(${({ url }) => url});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
`;
const OuterCircle = styled.div `
  position: relative;
  box-sizing: border-box;
  width: ${({ theme, size }) => theme.avatar.diameter[size]};
  height: ${({ theme, size }) => theme.avatar.diameter[size]};
  border-radius: 50%;
  border: ${({ theme, size }) => size === 'LARGE'
    ? `solid 0.09375rem ${theme.colors.INK_400}`
    : `solid 0.0625rem ${theme.colors.INK_400}`};
  background-color: ${({ theme }) => theme.colors.SNOW_100};
`;
const InnerCircle = styled.div `
  position: absolute;
  top: ${({ size }) => (size === 'LARGE' ? `0.1563rem` : `0.0625rem`)};
  left: ${({ size }) => (size === 'LARGE' ? `0.15625rem` : `0.0625rem`)};
  width: ${({ theme, size }) => theme.avatar.innerDiameter[size]};
  height: ${({ theme, size }) => theme.avatar.innerDiameter[size]};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.INK_400};
  color: ${({ theme }) => theme.colors.SNOW_100};
  text-align: center;
`;
const Name = styled.div `
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: 600;
  white-space: nowrap;
  font-size: ${({ theme, size = 'MEDIUM' }) => theme.avatar.fontSize[size]};
`;
export const Default = ({ size = 'MEDIUM', name, }) => (React.createElement(OuterCircle, { size: size },
    React.createElement(InnerCircle, { size: size },
        React.createElement(Name, { size: size }, name && name.length >= 2 ? name.substring(0, 2) : name))));
export const Image = ({ size = 'MEDIUM', url, }) => React.createElement(Icon, { size: size, url: url });
//# sourceMappingURL=Avatar.js.map